// eslint-disable-next-line import/prefer-default-export
export const muiMenuComponent = {
  defaultProps: {
    disablePortal: true,
    slotProps: {
      paper: {
        elevation: 1,
      },
    },
  },
  styleOverrides: {
    paper: ({ theme }) => ({
      padding: theme.spacing('NONE'),
    }),
    list: ({ theme }) => ({
      padding: theme.spacing('NONE'),
    }),
  },
};
